// extracted by mini-css-extract-plugin
module.exports = {"bracketInfo":"BracketInfo_bracketInfo__d_ndS","container":"BracketInfo_container__ayxx_","label":"BracketInfo_label__Oiofl","value":"BracketInfo_value__gHPmn"};